import { render, staticRenderFns } from "./RestaurantsTab.vue?vue&type=template&id=706aa0ab"
import script from "./RestaurantsTab.vue?vue&type=script&lang=js"
export * from "./RestaurantsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports